import { createContext, useContext, type ReactNode } from "react"

const AgentColumnChromeContext = createContext(false)

/** Правая колонка внутри split: её чат пишет busy и непрочитанный ответ в стор тулбара. */
export function AgentColumnChromeProvider({ children }: { children: ReactNode }) {
  return <AgentColumnChromeContext.Provider value={true}>{children}</AgentColumnChromeContext.Provider>
}

export function useAgentColumnChrome(): boolean {
  return useContext(AgentColumnChromeContext)
}
